import type { ReactNode } from 'react';
import { css, mediaQueries } from '@eti/styles';

const slidesWrapperStyles = (version: number) => css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-inline: ${version === 1 ? '-8px' : '-16px'};
  overflow: scroll hidden;
  -webkit-overflow-scrolling: touch; /* Important for iOS devices */
  scroll-snap-type: x mandatory;

  @media (min-width: 431px) {
    margin-inline: 0;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

const slideStyles = (version: number) => css`
  flex-shrink: 0;
  position: relative;
  scroll-snap-align: center;
  scroll-snap-stop: always;
  width: 236px;
  z-index: 2;

  &:first-child {
    margin-left: ${version === 1 ? '8px' : '16px'};
  }

  &:last-child {
    margin-right: ${version === 1 ? '8px' : '16px'};
  }

  @media (min-width: 431px) {
    flex: 1;
    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  @media ${mediaQueries.medium.up} {
    flex: 0 0 49%;
    max-width: 49%;
  }

  @media ${mediaQueries.large.up} {
    scroll-snap-align: none;
  }
`;

export const Slide = ({ children, version, ...rest }: { children: ReactNode; version: number }) => (
  <div className={slideStyles(version)} {...rest}>
    {children}
  </div>
);

interface CarouselProps {
  children: ReactNode;
  version: number;
}

export const Carousel = ({ children, version }: CarouselProps) => {
  return <div className={slidesWrapperStyles(version)}>{children}</div>;
};
